import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-939e473c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exam-score-chart-wrap" }
const _hoisted_2 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { getElColorPrimary } from '@/utils/theme-color'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'

import type { ScoreDistribution } from '../examination-status.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'exam-score-chart',
  props: {
  /** 体检分数分布数据 */
  rawData: {
    type: Object as () => ScoreDistribution | undefined,
    default: undefined,
  },
},
  emits: ["sliceClick"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)
const { t } = useI18n()

const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

/**
 * 与列表「体检分数」筛选项 value 一致：3=100分、2=60~99、1=60以下（见 examination-table score_range dictData）
 */
const chartData = computed(() => {
  if (!props.rawData) return []
  return [
    { name: t('examinationTable.scoreFull'), value: props.rawData.count_100, color: '#31C872', score_range: 3 as const },
    { name: t('examinationTable.score60to99'), value: props.rawData.count_60_99, color: getElColorPrimary(), score_range: 2 as const },
    { name: t('examinationTable.scoreBelow60'), value: props.rawData.count_below_60, color: '#E54545', score_range: 1 as const },
  ]
})

const totalCount = computed(() =>
  chartData.value.reduce((sum, item) => sum + item.value, 0)
)

const hasData = computed(() => totalCount.value > 0)

function getChartData () {
  return chartData.value.map(item => ({
    value: item.value,
    name: item.name,
    score_range: item.score_range,
    itemStyle: {
      color: item.color,
    },
  }))
}

function createChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
}

function getChartOption () {
  const option = {
    series: [{
      name: t('examinationTable.chartSeriesTerminalCount'),
      data: getChartData(),
    }],
  }

  return getAssignPieOption(option, { unit: t('portManage.unitTerminal') })
}

function bindSliceClick () {
  if (!chartInstance) return
  chartInstance.off('click')
  chartInstance.on('click', (params: { data?: { score_range?: number } }) => {
    const r = params.data?.score_range
    if (r === 1 || r === 2 || r === 3) {
      emit('sliceClick', { score_range: r })
    }
  })
}

function renderChart () {
  if (!chartInstance) return
  chartInstance.setOption(getChartOption())
  bindSliceClick()
}

function initChart () {
  chartInstance?.dispose()
  createChart()
  renderChart()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance?.resize()
})

watch(() => props.rawData, () => {
  if (!hasData.value) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasData.value) {
    setTimeout(() => initChart(), 100)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance?.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('examinationTable.chartTitleScoreDistribution')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "chartRef",
            ref: chartRef,
            class: "chart"
          }, null, 512),
          _createVNode(PieCenter, {
            title: _ctx.$t('examinationTable.pieCenterTotal'),
            value: totalCount.value,
            unit: _ctx.$t('portManage.unitTerminal')
          }, null, 8, ["title", "value", "unit"])
        ], 512), [
          [_vShow, hasData.value]
        ]),
        _withDirectives(_createVNode(EmptyData, {
          height: "100%",
          "bg-color": "transparent"
        }, null, 512), [
          [_vShow, !hasData.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})